import { useEffect, useState } from "react";

interface ShareBarProps {
  title: string;
  summary: string;
}

export default function ShareBar({ title, summary }: ShareBarProps) {
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast(`复制失败，请手动复制：${url}`);
    }
  };

  const shareText = encodeURIComponent(`${title} - ${summary}`);

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={handleCopy}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
      >
        <i className="ri-link"></i>
        复制链接
      </button>
      <a
        href={`https://service.weibo.com/share/share.php?title=${shareText}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="分享到微博"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600"
      >
        <i className="ri-weibo-fill"></i>
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${shareText}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="分享到 X"
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600"
      >
        <i className="ri-twitter-x-fill"></i>
      </a>

      {toast && (
        <span className="absolute left-0 top-12 z-20 rounded-md bg-foreground-950 px-3 py-2 text-xs text-background-50 animate-fade">
          {toast}
        </span>
      )}
    </div>
  );
}